import { render, staticRenderFns } from "./multipleImages.vue?vue&type=template&id=2d7837b0"
import script from "./multipleImages.vue?vue&type=script&lang=js"
export * from "./multipleImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports